import {
    AfterViewInit, ChangeDetectorRef,
    Component,
    ComponentFactoryResolver,
    EventEmitter,
    Input,
    OnInit,
    Output, QueryList,
    ViewChildren,
    ViewContainerRef
} from '@angular/core';
import {NoosFormTypeService} from '../../../../class/NoosFormTypeService';
import {FormItemComponentInterface, ISurveySelectedEvent, SurveyFormItemComponentInterface} from '../../../../interface/component';
import {IFormItemsControls} from '../../../../interface/form-structure';
import {IFieldShema} from '@usteknoloji/noosgrid';
import {GlobalObjectService} from '../../../../class/global-obj';
import * as _ from 'lodash';

@Component({
    selector: 'noos-view-survey',
    templateUrl: './view-survey.component.html',
    styleUrls: ['./view-survey.component.scss']
})

@NoosFormTypeService.register('viewSurvey')
export class ViewSurveyComponent implements OnInit, AfterViewInit, FormItemComponentInterface {

    @ViewChildren('dynamic', {read: ViewContainerRef}) public widgetTargets: QueryList<ViewContainerRef>;

    prop: IFormItemsControls;
    isFilter = false;

    isForm = false;

    @Output()
    keyOnEnter: EventEmitter<any> = new EventEmitter<any>();

    @Input()
    datasetId = 0;

    @Input()
    formId = 0;

    recordId = 0;

    formFieldStructure: IFieldShema[];
    formRecordData: any;
    pkeys: any;

    surveyReturns: ISurveySelectedEvent[] = [];

    constructor(private cd: ChangeDetectorRef, private componentFactoryResolver: ComponentFactoryResolver,
                private noosFormTypeFactory: NoosFormTypeService,) {
    }

    ngOnInit(): void {

        this.formFieldStructure = _.orderBy(GlobalObjectService.getVar('formFieldStructure_' + this.formId.toString()), ['list_order'], ['ASC']);
        this.formRecordData = GlobalObjectService.getVar('formRecordData_' + this.formId.toString());
        this.pkeys = GlobalObjectService.getVar('pkeys_' + this.formId.toString());
    }

    ngAfterViewInit(): void {
        if (this.prop.options.field_name !== undefined) {
            let fieldAlias='';
            const isField = this.formFieldStructure.filter(i => i.field_name === this.prop.options.field_name);
            if (isField.length > 0) {
                fieldAlias = isField[0].field_alias;
            }
            this.surveyReturns = this.formRecordData[fieldAlias];
            this.cd.detectChanges();
            this.widgetTargets.changes.subscribe(() => {
                this.compileForm();
            });
            this.compileForm();
        }
    }

    compileForm() {
        for (let i = 0; i < this.widgetTargets.toArray().length; i++) {
            const conf = this.surveyReturns[i];
            if (conf) {
                const target = this.widgetTargets.toArray()[i];
                target.clear();
                const component = this.noosFormTypeFactory.getPostTypeFromString('survey-' + conf.question.answer_control_id);
                if (component === null) {
                    return;
                }
                const componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);
                const componentRef = target.createComponent(componentFactory);
                (componentRef.instance as SurveyFormItemComponentInterface).prop = conf.question;
                (componentRef.instance as SurveyFormItemComponentInterface).answers = conf.answers;
                (componentRef.instance as SurveyFormItemComponentInterface).isView = true;
                (componentRef.instance as SurveyFormItemComponentInterface).datasetId = this.datasetId;
                (componentRef.instance as SurveyFormItemComponentInterface).formId = this.formId;
                (componentRef.instance as SurveyFormItemComponentInterface).isFilter = this.isFilter;
                (componentRef.instance as SurveyFormItemComponentInterface).index = i + 1;
                componentRef.changeDetectorRef.detectChanges();
                this.cd.detectChanges();


            }
        }

    }

}
